import { SessionStorageContext, SessionStorageContextRecord, SessionStorageStore } from 'lib/context/app'
import { FC, ReactNode, useMemo, useState } from 'react'

export const SessionStorageContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [store, setStore] = useState<SessionStorageStore>({})

    const value = useMemo(() => new SessionStorageContextRecord({ store, setStore }), [store, setStore])

    return <SessionStorageContext.Provider value={value}>
        {children}
    </SessionStorageContext.Provider>
}
